import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getMe } from '../lib/api';
import { Loader2 } from 'lucide-react';

const ONIRVA_ICON = "https://customer-assets.emergentagent.com/job_200ec0e0-0820-4417-b1b5-b6286eb18bc4/artifacts/c3nyk9fu_80AC8250-CA42-4BF9-BA0D-F1211AA6A764.png";

export function ProtectedRoute({ children, requireOnboarding = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);
  const [user, setUser] = useState(location.state?.user || null);
  
  useEffect(() => {
    // Skip if user was passed from AuthCallback
    if (location.state?.user) {
      setUser(location.state.user);
      setIsAuthenticated(true);
      
      // Check onboarding requirement
      if (requireOnboarding && !location.state.user.has_completed_onboarding) {
        navigate('/onboarding', { replace: true });
      }
      return;
    }
    
    const checkAuth = async () => {
      try {
        // First check localStorage for token
        const token = localStorage.getItem('onirva_token');
        const storedUser = localStorage.getItem('onirva_user');
        
        if (!token && !storedUser) {
          // No local auth, try cookie auth via /auth/me
          const response = await getMe();
          const userData = response.data;
          localStorage.setItem('onirva_user', JSON.stringify(userData));
          setUser(userData);
          setIsAuthenticated(true);
          
          if (requireOnboarding && !userData.has_completed_onboarding) {
            navigate('/onboarding', { replace: true });
          }
          return;
        }
        
        // Verify with backend
        const response = await getMe();
        const userData = response.data;
        localStorage.setItem('onirva_user', JSON.stringify(userData));
        setUser(userData);
        setIsAuthenticated(true);
        
        if (requireOnboarding && !userData.has_completed_onboarding) {
          navigate('/onboarding', { replace: true });
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        localStorage.removeItem('onirva_token');
        localStorage.removeItem('onirva_user');
        setIsAuthenticated(false);
        navigate('/login', { replace: true });
      }
    };
    
    checkAuth();
  }, [navigate, requireOnboarding, location.state]);
  
  // Loading state
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <img src={ONIRVA_ICON} alt="ONIRVA" className="w-16 h-16 mx-auto mb-4 rounded-2xl animate-pulse" />
          <Loader2 className="w-6 h-6 animate-spin mx-auto text-primary" />
        </div>
      </div>
    );
  }
  
  // Not authenticated
  if (!isAuthenticated) {
    return null;
  }
  
  return children;
}

export default ProtectedRoute;
